import React from 'react';

const AppInformation: React.FC = () => {
  return (
    <section className="bg-white rounded-2xl shadow-lg p-6 mb-8">
      <h2 className="text-2xl font-bold text-black mb-6">Thông tin</h2>
      <div className="grid md:grid-cols-2 gap-8">
        <div>
          <h3 className="font-semibold text-black mb-4">Nhà phát triển</h3>
          <div className="space-y-3">
            <div className="flex justify-between">
              <span className="text-gray-600">Tên</span>
              <span className="text-black">Huynh Thang</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Danh mục</span>
              <span className="text-black">Mạng xã hội</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Tương thích</span>
              <span className="text-black">iPhone, iPad</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Ngôn ngữ</span>
              <span className="text-black">Tiếng Việt, English</span>
            </div>
          </div>
        </div>
        
        <div>
          <h3 className="font-semibold text-black mb-4">Chi tiết</h3>
          <div className="space-y-3">
            <div className="flex justify-between">
              <span className="text-gray-600">Phiên bản</span>
              <span className="text-black">1.2.0</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Kích thước</span>
              <span className="text-black">45.2 MB</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Độ tuổi</span>
              <span className="text-black">4+</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Bản quyền</span>
              <span className="text-black">© 2024 Locuno</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppInformation;
